import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { ApiService } from 'services/api.service';
import { ClaimDirective } from 'src/app/directive/claim.directive';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { ReadingRoomCard } from 'types/reading-room.interface';
import { CLAIM_SCOPES, CLAIM_TYPES } from 'types/user.interface';
import { formatDate } from 'util/date.utility';
import { formatTimeWithoutSeconds } from 'util/form.utility';
import { isNotificationVisible, sortSchedule } from 'util/reading-room.utility';
import { allowEditReadingRoom } from 'util/user.utility';
export const MINUTES_IN_HOUR = 60;

@Component({
  selector: 'app-view-reading-room-page',
  standalone: true,
  imports: [TranslateModule, BreadcrumbsComponent, SpinnerComponent, ClaimDirective, TooltipComponent],
  templateUrl: './view-reading-room-page.component.html',
  styleUrl: './view-reading-room-page.component.scss'
})
export class ViewReadingRoomPageComponent implements OnInit {
  public readonly CLAIM_SCOPE = CLAIM_SCOPES['readingRoom'];
  public readonly CLAIM_TYPES = CLAIM_TYPES;
  public readonly formatDate = formatDate;
  public readonly isNotificationVisible = isNotificationVisible;
  public readonly formatTimeWithoutSeconds = formatTimeWithoutSeconds;
  public readonly allowEditReadingRoom = allowEditReadingRoom;
  id: string | null = null;
  readingRoom?: ReadingRoomCard;
  isLoading: boolean = true;
  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.readingRooms',
      url: '/lasitavas'
    }
  ];

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const id: string = params.get('id') || '';

      if (id.length > 0) {
        this.id = id;

        this.apiService.getReadingRoom(this.id).subscribe(
          (data: any) => {
            this.readingRoom = data;

            if (this.readingRoom?.scheduleEntries) {
              this.readingRoom.scheduleEntries = sortSchedule(this.readingRoom?.scheduleEntries || []);
            }

            this.breadcrumbs.push({
              title: data.name,
              url: `/lasitava/${this.id}`
            });

            this.isLoading = false;
          },
          (error: any) => {
            console.error(error);
          }
        );
      }
    });
  }

  toLowercase(str: string): string {
    return str.toLowerCase();
  }

  navigateToEditPage() {
    if (this.id) {
      this.router.navigate([`/lasitavas/${this.id}/rediget`]);
    }
  }
}
